export default __webpack_public_path__ + "static/media/atm.4e9a28b6.PNG";